import HeroSection from './components/HeroSection';
import WhyUsSection from './components/WhyUsSection';
import ServicesSection from './components/ServicesSection';
import HowItWorksSection from './components/HowItWorksSection';
import CTASection from './components/CTASection';

export default function HomePage() {
  return (
    <main>
      <HeroSection />
      <WhyUsSection />
      <ServicesSection />
      <HowItWorksSection />
      <CTASection />
    </main>
  );
}
